// extracted by mini-css-extract-plugin
export default {"detailLayout":"RulesTab_detailLayout__3MdDK","mainCol":"RulesTab_mainCol__1qSUY"};